import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "@/routes/ProtectedRoute";
import { LoginPage } from "@/routes/LoginPage";
import { DashboardPage } from "@/routes/DashboardPage";

// ADR-072 Rule FMS-03: هر دامنه routes خودش را export می‌کند، اینجا فقط
// aggregate می‌شود. اضافه‌کردن یک app جدید بک‌اند = یک خط اینجا، نه بیشتر.
import { inventoryRoutes } from "@/features/inventory";
import { bomRoutes } from "@/features/bom";
import { routingRoutes } from "@/features/routing";
import { productionRoutes } from "@/features/production";
import { organizationRoutes } from "@/features/organization";
import { qualityRoutes } from "@/features/quality";
import { MarketplaceRoutes } from "@/features/marketplace";
import { workflowRoutes } from "@/features/workflow";
import { formsRoutes } from "@/features/forms";
import { planningRoutes } from "@/features/planning/routes";
import { reportingRoutes } from "@/features/reporting";
import { printingRoutes } from "@/features/printing";
import { remoteAssistRoutes } from "@/features/remoteAssist/routes";

function DjangoAdminRedirect() {
  const backendAdminUrl = import.meta.env.VITE_API_BASE_URL
    ? `${import.meta.env.VITE_API_BASE_URL}/admin/`
    : "/admin/";
  window.location.href = backendAdminUrl;
  return (
    <div style={{ padding: "3rem", textAlign: "center", fontFamily: "var(--font-family-fa, sans-serif)", color: "var(--color-text-main)" }}>
      <h2>در حال انتقال به پنل مدیریت سرور (Django Admin)...</h2>
      <p style={{ color: "var(--color-text-muted)", marginTop: "0.5rem" }}>
        در صورتی که به‌صورت خودکار منتقل نشدید، <a href={backendAdminUrl} style={{ color: "#2563eb", fontWeight: "bold" }}>اینجا کلیک کنید</a>.
      </p>
    </div>
  );
}

import { TicketPage } from "@/features/support/pages/TicketPage";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/admin",
    element: <DjangoAdminRedirect />,
  },
  {
    path: "/admin/*",
    element: <DjangoAdminRedirect />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        element: <DashboardPage />,
      },
      ...inventoryRoutes,
      ...bomRoutes,
      ...routingRoutes,
      ...productionRoutes,
      ...organizationRoutes,
      ...qualityRoutes,
      ...MarketplaceRoutes,
      ...workflowRoutes,
      ...formsRoutes,
      ...planningRoutes,
      ...reportingRoutes,
      ...printingRoutes,
      ...remoteAssistRoutes,
      {
        path: "/support/tickets/new",
        element: <TicketPage />,
      },
    ],
  },
]);
